import { timer } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { HttpService } from '../../../globals/providers/http.service';
import { AppEndpoints } from '../../app.endpoints';
import {
	ISendCodeRequest,
	IVerifyCodeRequest,
} from '../../classes/existing-onboarding-customer/requests';
import { ISendCodeResponse } from '../../classes/existing-onboarding-customer/responses';

export class ExistingOnboardingVerificationService {
	public static sendCode(
		request: ISendCodeRequest,
		mock: boolean = false
	): Observable<ISendCodeResponse> {
		if (mock == true) {
			return this.sendCodeMock(request);
		} else {
			return HttpService.post<ISendCodeResponse>(AppEndpoints.sendCode, request);
		}
	}
	public static verifyCode(
		request: IVerifyCodeRequest,
		mock: boolean = false
	): Observable<boolean> {
		if (mock == true) {
			return this.verifyCodeMock(request);
		} else {
			return HttpService.post<boolean>(AppEndpoints.verifyCode, request);
		}
	}
	private static sendCodeMock(request: ISendCodeRequest): Observable<ISendCodeResponse> {
		let dummyResponse: ISendCodeResponse = {
			appId: request.appId,
			verificationResult: {
				expiresOn: '2021-03-25T07:25:23.570Z',
				verificationId: request.appId,
			},
		};

		return timer(2500).pipe(map(() => dummyResponse));
	}
	private static verifyCodeMock(request: IVerifyCodeRequest): Observable<boolean> {
		let dummyResponse: boolean = true;

		return timer(2500).pipe(map(() => dummyResponse));
	}
}
